/* ==========================================================================
   KD Shop — theme JavaScript
   ========================================================================== */
(function () {
  'use strict';

  const money = (cents) => {
  const amount = cents / 100;
  const formatted = amount % 1 === 0
    ? amount.toLocaleString(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })
    : amount.toLocaleString(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'USD',
      });
  return formatted;
};


  /* --- Mobile navigation drawer ------------------------------------------ */
  function initMobileNav() {
    const toggle = document.querySelector('[data-mobile-nav-toggle]');
    const nav = document.querySelector('[data-mobile-nav]');
    if (!toggle || !nav) return;

    const open = () => nav.classList.add('is-open');
    const close = () => nav.classList.remove('is-open');

    toggle.addEventListener('click', open);
    nav.querySelectorAll('[data-mobile-nav-close], .mobile-nav__overlay').forEach((el) =>
      el.addEventListener('click', close)
    );
    document.addEventListener('keydown', (e) => e.key === 'Escape' && close());
  }

  /* --- Transparent header over the hero ---------------------------------- */
  function initTransparentHeader() {
    const header = document.querySelector('[data-transparent]');
    if (!header) return;
    document.body.classList.add('header-transparent');

    const setHeight = () =>
      document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px');
    setHeight();
    window.addEventListener('resize', setHeight);

    // Only treat the first section as a full-screen hero on banner pages;
    // elsewhere the header turns solid as soon as you scroll (keeps the menu readable).
    const heroTemplates = ['index'];
    const hasHero = heroTemplates.some((t) => document.body.classList.contains('template-' + t));
    const hero = document.querySelector('#MainContent > .shopify-section:first-child');
    const onScroll = () => {
      const threshold = hasHero && hero
        ? Math.max(hero.offsetHeight - header.offsetHeight, 50)
        : 8;
      header.classList.toggle('is-solid', window.scrollY > threshold);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* --- Sticky header shadow on scroll ------------------------------------ */
  function initStickyHeader() {
    const header = document.querySelector('[data-sticky]');
    if (!header) return;
    const onScroll = () => header.classList.toggle('is-stuck', window.scrollY > 4);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* --- Mega menu (desktop) ----------------------------------------------- */
  function initMegaMenu() {
    const items = Array.from(document.querySelectorAll('[data-nav-item]'));
    if (!items.length) return;
    let closeTimer = null;

    const setState = (item, open) => {
      item.classList.toggle('is-open', open);
      item.querySelector('[data-nav-trigger]')?.setAttribute('aria-expanded', String(open));
    };
    const openItem = (item) => {
      items.forEach((other) => other !== item && setState(other, false));
      setState(item, true);
    };
    const closeAll = () => items.forEach((item) => setState(item, false));

    items.forEach((item) => {
      const trigger = item.querySelector('[data-nav-trigger]');

      item.addEventListener('mouseenter', () => {
        clearTimeout(closeTimer);
        openItem(item);
      });
      item.addEventListener('mouseleave', () => {
        closeTimer = setTimeout(() => setState(item, false), 150);
      });

      // First activation (keyboard/touch) opens; second lets the link navigate
      trigger?.addEventListener('click', (e) => {
        if (!item.classList.contains('is-open')) {
          e.preventDefault();
          openItem(item);
        }
      });

      // Close when focus leaves the whole item (keyboard tabbing out)
      item.addEventListener('focusout', (e) => {
        if (!item.contains(e.relatedTarget)) setState(item, false);
      });
    });

    document.addEventListener('keydown', (e) => e.key === 'Escape' && closeAll());
    document.addEventListener('click', (e) => {
      if (!e.target.closest('[data-nav-item]')) closeAll();
    });
  }

  /* --- Mobile submenu accordions ----------------------------------------- */
  function initMobileSubmenus() {
    document.querySelectorAll('[data-mobile-submenu-toggle]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const sublist = btn.closest('.mobile-nav__parent')?.nextElementSibling;
        const open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        if (sublist) sublist.hidden = open;
      });
    });
  }

  /* --- Cart drawer ------------------------------------------------------- */
  const CartDrawer = {
    el: null,
    init() {
      this.el = document.querySelector('[data-cart-drawer]');
      if (!this.el) return;
      document.querySelectorAll('[data-cart-toggle]').forEach((btn) =>
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.open();
        })
      );
      this.el
        .querySelectorAll('[data-drawer-close], .drawer__overlay')
        .forEach((el) => el.addEventListener('click', () => this.close()));
      document.addEventListener('keydown', (e) => e.key === 'Escape' && this.close());

      // Quantity + remove inside the drawer (AJAX, no reload)
      this.el.addEventListener('click', (e) => {
        const step = e.target.closest('[data-drawer-qty]');
        if (step) {
          const row = step.closest('[data-drawer-line]');
          const input = row.querySelector('input');
          const dir = step.dataset.drawerQty === 'up' ? 1 : -1;
          const next = Math.max(0, Number(input.value) + dir);
          this.changeQty(row.dataset.drawerLine, next);
          return;
        }
        const remove = e.target.closest('[data-drawer-remove]');
        if (remove) {
          e.preventDefault();
          this.changeQty(remove.dataset.drawerRemove, 0);
        }
      });
    },
    async changeQty(line, quantity) {
      try {
        await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: Number(line), quantity: Number(quantity) }),
        });
        await this.refresh();
        updateCartCount();
      } catch (err) {
        console.error(err);
      }
    },
    open() {
      this.el?.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      document.querySelector('[data-quickview-modal]')?.classList.remove('is-open');
      loadDrawerRecos();
    },
    close() {
      this.el?.classList.remove('is-open');
      document.body.style.overflow = '';
    },
    async refresh() {
      if (!this.el) return;
      const res = await fetch(`${window.Shopify?.routes?.root || '/'}?section_id=cart-drawer`);
      const text = await res.text();
      const html = new DOMParser().parseFromString(text, 'text/html');
      const fresh = html.querySelector('[data-cart-drawer-contents]');
      const target = this.el.querySelector('[data-cart-drawer-contents]');
      if (fresh && target) target.innerHTML = fresh.innerHTML;
      loadDrawerRecos();
    },
  };

  /* --- Cart drawer cross-sell (lazy) ------------------------------------- */
  async function loadDrawerRecos() {
    const box = document.querySelector('[data-drawer-recos]');
    if (!box) return;
    const pid = box.dataset.productId;
    if (!pid) { box.hidden = true; return; }
    if (box.dataset.loaded === pid) return;
    box.dataset.loaded = pid;
    const root = window.Shopify?.routes?.root || '/';
    const sized = (u) => (u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '');
    const esc = (s) => String(s || '').replace(/"/g, '&quot;');
    const inCart = (box.dataset.cartIds || '').split(',');
    const fetchRecos = async (intent) => {
      const res = await fetch(`${root}recommendations/products.json?product_id=${pid}&intent=${intent}&limit=10`);
      const data = await res.json();
      return (data.products || [])
        .filter((p) => p.available && inCart.indexOf(String(p.id)) === -1)
        .slice(0, 6);
    };
    try {
      // Complementary cross-sells first; fall back to related so it's never empty.
      let items = await fetchRecos('complementary');
      if (!items.length) items = await fetchRecos('related');
      if (!items.length) { box.hidden = true; return; }
      const rows = items
        .map((p) => {
          const v = p.variants && p.variants.length === 1 && p.variants[0].available ? p.variants[0] : null;
          const add = v
            ? `<form action="${root}cart/add" method="post" class="drawer-reco__form" data-adding="${esc(box.dataset.adding)}"><input type="hidden" name="id" value="${v.id}"><button type="submit" class="drawer-reco__add" aria-label="${esc(box.dataset.addLabel)}">+</button></form>`
            : `<a href="${p.url}" class="drawer-reco__add" aria-label="${esc(box.dataset.addLabel)}">+</a>`;
          return `<div class="drawer-reco">
              <a href="${p.url}" class="drawer-reco__media"><img src="${sized(p.featured_image)}" alt="${esc(p.title)}" loading="lazy"></a>
              <div class="drawer-reco__info">
                <a href="${p.url}" class="drawer-reco__name">${esc(p.title)}</a>
                <span class="drawer-reco__price">${money(p.price)}</span>
              </div>
              ${add}
            </div>`;
        })
        .join('');
      box.innerHTML = `<p class="drawer-recos__title">${esc(box.dataset.title)}</p><div class="drawer-recos__track">${rows}</div>`;
      box.hidden = false;
    } catch (_) {
      box.hidden = true;
    }
  }

  /* --- Add to cart (AJAX) ------------------------------------------------- */
  function initAddToCart() {
    document.addEventListener('submit', async (e) => {
      const form = e.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      e.preventDefault();

      const btn = form.querySelector('[type="submit"]');
      const label = btn?.innerHTML;
      if (btn) {
        btn.setAttribute('aria-disabled', 'true');
        btn.innerHTML = form.dataset.adding || 'Adding…';
      }

      try {
        const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || 'Error');

        await updateCartCount();
        await CartDrawer.refresh();
        CartDrawer.open();
      } catch (err) {
        console.error(err);
        alert(err.message);
      } finally {
        if (btn) {
          btn.removeAttribute('aria-disabled');
          btn.innerHTML = label;
        }
      }
    });
  }

  /* --- Cart count -------------------------------------------------------- */
  async function updateCartCount() {
    try {
      const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`);
      const cart = await res.json();
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
      });
    } catch (_) {}
  }

  /* --- Predictive search popup ------------------------------------------- */
  const SearchModal = {
    el: null,
    input: null,
    results: null,
    timer: null,
    controller: null,
    init() {
      this.el = document.querySelector('[data-search-modal]');
      if (!this.el) return;
      this.input = this.el.querySelector('[data-predictive-input]');
      this.results = this.el.querySelector('[data-predictive-results]');

      document.querySelectorAll('[data-search-toggle]').forEach((btn) =>
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.open();
        })
      );
      this.el
        .querySelectorAll('[data-search-close], .search-modal__overlay')
        .forEach((el) => el.addEventListener('click', () => this.close()));
      document.addEventListener('keydown', (e) => e.key === 'Escape' && this.close());

      this.input.addEventListener('input', () => this.onInput());
    },
    open() {
      this.el.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      setTimeout(() => this.input.focus(), 60);
    },
    close() {
      this.el.classList.remove('is-open');
      document.body.style.overflow = '';
    },
    onInput() {
      clearTimeout(this.timer);
      const query = this.input.value.trim();
      if (query.length < 2) {
        this.results.innerHTML = '';
        return;
      }
      this.timer = setTimeout(() => this.search(query), 250);
    },
    async search(query) {
      this.results.innerHTML = '<div class="search-modal__loading">' + (this.input.dataset.searching || 'Searching…') + '</div>';
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      try {
        const root = window.Shopify?.routes?.root || '/';
        const url =
          `${root}search/suggest?q=${encodeURIComponent(query)}` +
          `&section_id=predictive-search` +
          `&resources[type]=product,collection,page&resources[limit]=8`;
        const res = await fetch(url, { signal: this.controller.signal });
        const html = await res.text();
        this.results.innerHTML = html.trim();
      } catch (err) {
        if (err.name !== 'AbortError') console.error(err);
      }
    },
  };

  /* --- Toast notifications ----------------------------------------------- */
  const Toast = {
    stack: null,
    ensure() {
      if (this.stack) return this.stack;
      this.stack = document.createElement('div');
      this.stack.className = 'toast-stack';
      this.stack.setAttribute('aria-live', 'polite');
      document.body.appendChild(this.stack);
      return this.stack;
    },
    show(message, type = 'success', duration = 4500) {
      if (!message) return;
      const el = document.createElement('div');
      el.className = `toast toast--${type}`;
      el.setAttribute('role', 'status');
      el.innerHTML =
        `<span class="toast__msg"></span>` +
        `<button type="button" class="toast__close" aria-label="close">&times;</button>`;
      el.querySelector('.toast__msg').textContent = message;
      this.ensure().appendChild(el);
      requestAnimationFrame(() => el.classList.add('is-visible'));

      const remove = () => {
        el.classList.remove('is-visible');
        setTimeout(() => el.remove(), 350);
      };
      const timer = setTimeout(remove, duration);
      el.querySelector('.toast__close').addEventListener('click', () => {
        clearTimeout(timer);
        remove();
      });
    },
  };

  // Queue a message to show after a page navigation.
  function setFlash(message, type = 'success') {
    try {
      sessionStorage.setItem('kd-flash', JSON.stringify({ message, type }));
    } catch (_) {}
  }
  function initFlash() {
    try {
      const raw = sessionStorage.getItem('kd-flash');
      if (!raw) return;
      sessionStorage.removeItem('kd-flash');
      const { message, type } = JSON.parse(raw);
      Toast.show(message, type || 'success');
    } catch (_) {}
  }

  /* --- Account popup (login / register / recover) ------------------------ */
  const AccountModal = {
    el: null,
    init() {
      this.el = document.querySelector('[data-account-modal]');
      if (!this.el) return;

      document.querySelectorAll('[data-account-toggle]').forEach((btn) =>
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.open();
        })
      );
      this.el
        .querySelectorAll('[data-account-close], .account-modal__overlay')
        .forEach((el) => el.addEventListener('click', () => this.close()));
      document.addEventListener('keydown', (e) => e.key === 'Escape' && this.close());

      this.el.querySelectorAll('[data-account-view-to]').forEach((btn) =>
        btn.addEventListener('click', () => this.showView(btn.dataset.accountViewTo))
      );

      this.el.querySelectorAll('.account-form').forEach((form) =>
        form.addEventListener('submit', (e) => this.submit(e, form))
      );
    },
    formType(form) {
      const action = form.getAttribute('action') || '';
      if (action.includes('/recover')) return 'recover';
      if (action.includes('/login')) return 'login';
      return 'register';
    },
    async submit(e, form) {
      e.preventDefault();
      const type = this.formType(form);
      const btn = form.querySelector('[type="submit"]');
      const label = btn ? btn.innerHTML : '';
      const errBox = form.querySelector('[data-account-error]');
      const okBox = form.querySelector('[data-account-success]');
      if (errBox) errBox.hidden = true;
      if (okBox) okBox.hidden = true;
      if (btn) {
        btn.disabled = true;
        btn.innerHTML = window.themeStrings?.loading || '…';
      }

      try {
        const res = await fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'text/html' },
        });
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const serverError = doc.querySelector('.form-status--error:not([data-account-error])');

        if (type === 'recover') {
          if (serverError && !res.redirected) this.showError(errBox, serverError.innerHTML);
          else if (okBox) okBox.hidden = false;
          return;
        }

        // login / register: a followed redirect means success
        if (res.redirected) {
          if (type === 'register') {
            setFlash(window.themeStrings?.welcomeNew, 'success');
            window.location.href = window.Shopify?.routes?.root || '/';
          } else {
            setFlash(window.themeStrings?.welcomeBack, 'success');
            window.location.href = res.url;
          }
          return;
        }
        this.showError(errBox, serverError ? serverError.innerHTML : (window.themeStrings?.accountError || 'Something went wrong. Please try again.'));
      } catch (err) {
        this.showError(errBox, window.themeStrings?.accountError || 'Something went wrong. Please try again.');
      } finally {
        if (btn) {
          btn.disabled = false;
          btn.innerHTML = label;
        }
      }
    },
    showError(box, html) {
      if (!box) return;
      box.innerHTML = html;
      box.hidden = false;
    },
    open(view) {
      this.el.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      if (view) this.showView(view);
      const active = this.el.querySelector('.account-view:not([hidden]) input');
      setTimeout(() => active?.focus(), 60);
    },
    close() {
      this.el.classList.remove('is-open');
      document.body.style.overflow = '';
    },
    showView(name) {
      this.el.querySelectorAll('[data-account-view]').forEach((v) => {
        v.hidden = v.dataset.accountView !== name;
      });
      const input = this.el.querySelector('.account-view:not([hidden]) input');
      setTimeout(() => input?.focus(), 40);
    },
  };

  /* --- Wishlist (localStorage) ------------------------------------------- */
  const WISHLIST_KEY = 'kd-wishlist';

  function getWishlist() {
    try {
      const raw = JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
      return raw
        .map((x) => (typeof x === 'string' ? { id: x } : x))
        .filter((x) => x && x.id != null);
    } catch (_) {
      return [];
    }
  }
  function saveWishlist(list) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
    updateWishlistCount();
    document.dispatchEvent(new CustomEvent('wishlist:change'));
  }
  function inWishlist(list, id) {
    return list.some((x) => String(x.id) === String(id));
  }
  function updateWishlistCount() {
    const count = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
      el.textContent = count;
    });
  }
  function markWishlistButtons() {
    const list = getWishlist();
    document.querySelectorAll('[data-wishlist-add]').forEach((btn) => {
      const active = inWishlist(list, btn.dataset.wishlistAdd);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', String(active));
    });
  }
  function initWishlist() {
    markWishlistButtons();
    updateWishlistCount();

    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-wishlist-add]');
      if (!btn) return;
      e.preventDefault();
      const id = btn.dataset.wishlistAdd;
      let list = getWishlist();
      const active = inWishlist(list, id);
      if (active) {
        list = list.filter((x) => String(x.id) !== String(id));
      } else {
        list.push({
          id: id,
          handle: btn.dataset.wishlistHandle || '',
          url: btn.dataset.wishlistUrl || '',
          title: btn.dataset.wishlistTitle || '',
          image: btn.dataset.wishlistImage || '',
          price: btn.dataset.wishlistPrice || '',
        });
      }
      saveWishlist(list);
      markWishlistButtons();
      Toast.show(
        active ? window.themeStrings?.wishlistRemoved : window.themeStrings?.wishlistAdded,
        'success',
        2500
      );
    });

    document.addEventListener('wishlist:change', updateWishlistCount);
  }

  /* --- Wishlist page ----------------------------------------------------- */
  function initWishlistPage() {
    const root = document.querySelector('[data-wishlist-page]');
    if (!root) return;
    const grid = root.querySelector('[data-wishlist-grid]');
    const empty = root.querySelector('[data-wishlist-empty]');
    if (!grid) return;

    function buildCard(p) {
      const el = document.createElement('div');
      el.className = 'card';
      el.innerHTML =
        '<div class="card__media-wrap"><a class="card__media"></a>' +
        '<div class="card__actions"><button type="button" class="card__action" data-wishlist-remove aria-label="Remove">&times;</button></div></div>' +
        '<div class="card__info"><h3 class="card__title"><a></a></h3>' +
        '<div class="card__price price"><span></span></div><a class="card__cta"></a></div>';
      const url = p.url || '#';
      el.querySelector('.card__media').href = url;
      if (p.image) {
        const img = document.createElement('img');
        img.src = p.image;
        img.alt = p.title || '';
        img.loading = 'lazy';
        el.querySelector('.card__media').appendChild(img);
      }
      el.querySelector('[data-wishlist-remove]').dataset.wishlistRemove = p.id;
      const titleA = el.querySelector('.card__title a');
      titleA.href = url;
      titleA.textContent = p.title || '';
      el.querySelector('.card__price span').textContent = p.price || '';
      const cta = el.querySelector('.card__cta');
      cta.href = url;
      cta.textContent = root.dataset.viewLabel || 'View product';
      return el;
    }

    function render() {
      const list = getWishlist();
      grid.innerHTML = '';
      const hasItems = list.length > 0;
      grid.hidden = !hasItems;
      if (empty) empty.hidden = hasItems;
      list.forEach((p) => grid.appendChild(buildCard(p)));
    }

    grid.addEventListener('click', (e) => {
      const rm = e.target.closest('[data-wishlist-remove]');
      if (!rm) return;
      e.preventDefault();
      const id = rm.dataset.wishlistRemove;
      saveWishlist(getWishlist().filter((x) => String(x.id) !== String(id)));
      markWishlistButtons();
      render();
    });

    document.addEventListener('wishlist:change', render);
    render();
  }

  /* --- Cart line item quantity / removal (cart page) --------------------- */
  function initCartChanges() {
    document.addEventListener('change', async (e) => {
      const input = e.target.closest('[data-cart-quantity]');
      if (!input) return;
      await changeCartLine(input.dataset.line, input.value);
    });
    document.addEventListener('click', async (e) => {
      const remove = e.target.closest('[data-cart-remove]');
      if (!remove) return;
      e.preventDefault();
      await changeCartLine(remove.dataset.line, 0);
    });
  }

  async function changeCartLine(line, quantity) {
    try {
      await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: Number(quantity) }),
      });
      window.location.reload();
    } catch (err) {
      console.error(err);
    }
  }

  /* --- Product gallery thumbnails ---------------------------------------- */
  function initGallery() {
    document.querySelectorAll('[data-gallery]').forEach((gallery) => {
      const main = gallery.querySelector('[data-gallery-main] img');
      const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
      gallery.dataset.current = '0';
      const show = (idx) => {
        const thumb = thumbs[idx];
        if (!main || !thumb) return;
        main.src = thumb.dataset.full;
        main.srcset = '';
        gallery.dataset.current = String(idx);
        thumbs.forEach((t) => t.setAttribute('aria-current', 'false'));
        thumb.setAttribute('aria-current', 'true');
      };
      thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => show(i)));
      const nav = (dir, e) => {
        if (e) { e.preventDefault(); e.stopPropagation(); }
        if (!thumbs.length) return;
        const cur = parseInt(gallery.dataset.current || '0', 10) || 0;
        show((cur + dir + thumbs.length) % thumbs.length);
      };
      gallery.querySelectorAll('[data-gallery-prev]').forEach((b) => b.addEventListener('click', (e) => nav(-1, e)));
      gallery.querySelectorAll('[data-gallery-next]').forEach((b) => b.addEventListener('click', (e) => nav(1, e)));
    });
  }

  /* --- Product image hover zoom (magnify) -------------------------------- */
  function initImageZoom() {
    if (window.matchMedia('(hover: none)').matches) return;
    document.querySelectorAll('[data-gallery-main]').forEach((box) => {
      const img = box.querySelector('img');
      if (!img) return;
      box.classList.add('has-zoom');
      box.addEventListener('mousemove', (e) => {
        const r = box.getBoundingClientRect();
        const x = ((e.clientX - r.left) / r.width) * 100;
        const y = ((e.clientY - r.top) / r.height) * 100;
        img.style.transformOrigin = x + '% ' + y + '%';
      });
      box.addEventListener('mouseenter', () => {
        img.style.transform = 'scale(2)';
      });
      box.addEventListener('mouseleave', () => {
        img.style.transform = '';
        img.style.transformOrigin = 'center';
      });
    });
  }

  /* --- Lightbox ---------------------------------------------------------- */
  const Lightbox = {
    el: null,
    imgEl: null,
    images: [],
    index: 0,
    init() {
      const data = document.querySelector('[data-gallery-images]');
      if (!data) return;
      try {
        this.images = JSON.parse(data.textContent);
      } catch (_) {
        return;
      }
      if (!this.images.length) return;

      this.el = document.createElement('div');
      this.el.className = 'lightbox';
      this.el.innerHTML =
        '<div class="lightbox__overlay" data-lb-close></div>' +
        '<button class="lightbox__close" data-lb-close aria-label="Close">&times;</button>' +
        '<button class="lightbox__nav lightbox__nav--prev" data-lb-prev aria-label="Previous">&lsaquo;</button>' +
        '<figure class="lightbox__stage"><img class="lightbox__img" alt=""></figure>' +
        '<button class="lightbox__nav lightbox__nav--next" data-lb-next aria-label="Next">&rsaquo;</button>' +
        '<div class="lightbox__count"><span data-lb-current>1</span> / ' + this.images.length + '</div>';
      document.body.appendChild(this.el);
      this.imgEl = this.el.querySelector('.lightbox__img');

      this.el.querySelectorAll('[data-lb-close]').forEach((b) => b.addEventListener('click', () => this.close()));
      this.el.querySelector('[data-lb-prev]').addEventListener('click', () => this.go(-1));
      this.el.querySelector('[data-lb-next]').addEventListener('click', () => this.go(1));

      document.querySelectorAll('[data-lightbox-open]').forEach((trigger) =>
        trigger.addEventListener('click', () => {
          let idx;
          if (trigger.dataset.lightboxIndex != null) {
            idx = parseInt(trigger.dataset.lightboxIndex, 10) || 0;
          } else {
            const gallery = trigger.closest('[data-gallery]');
            idx = parseInt(gallery?.dataset.current || '0', 10) || 0;
          }
          this.open(idx);
        })
      );

      document.addEventListener('keydown', (e) => {
        if (!this.el.classList.contains('is-open')) return;
        if (e.key === 'Escape') this.close();
        else if (e.key === 'ArrowLeft') this.go(-1);
        else if (e.key === 'ArrowRight') this.go(1);
      });

      // Swipe on touch
      let x0 = null;
      this.el.addEventListener('touchstart', (e) => (x0 = e.touches[0].clientX), { passive: true });
      this.el.addEventListener('touchend', (e) => {
        if (x0 === null) return;
        const dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) this.go(dx < 0 ? 1 : -1);
        x0 = null;
      });

      if (this.images.length < 2) {
        this.el.querySelectorAll('.lightbox__nav, .lightbox__count').forEach((x) => (x.hidden = true));
      }
    },
    open(i) {
      this.index = i;
      this.render();
      this.el.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    },
    close() {
      this.el.classList.remove('is-open');
      document.body.style.overflow = '';
    },
    go(d) {
      this.index = (this.index + d + this.images.length) % this.images.length;
      this.render();
    },
    render() {
      const im = this.images[this.index];
      this.imgEl.src = im.src;
      this.imgEl.alt = im.alt || '';
      const c = this.el.querySelector('[data-lb-current]');
      if (c) c.textContent = this.index + 1;
    },
  };

  /* --- Product variant selection ----------------------------------------- */
  function initVariants(scope) {
    (scope || document).querySelectorAll('[data-product-form]').forEach((form) => {
      if (form.dataset.vInit) return;
      form.dataset.vInit = '1';
      const data = form.querySelector('[data-variants-json]');
      if (!data) return;
      const variants = JSON.parse(data.textContent);
      const idInput = form.querySelector('[name="id"]');
      const root = form.closest('[data-product-root]') || document;
      const priceEl = root.querySelector('[data-product-price]');
      const btn = form.querySelector('[data-add-btn]');

      const selected = {};
      form.querySelectorAll('[data-option-index]').forEach((el) => {
        selected[el.dataset.optionIndex] = el.value || el.dataset.value;
      });

      function updateSelectedLabel(index, value) {
        const label = form.querySelector(
          `[data-option-group="${index}"] [data-option-selected]`
        );
        if (label) label.textContent = value;
      }

      function updateFromSelection() {
        const chosen = Object.keys(selected)
          .sort()
          .map((k) => selected[k]);
        const match = variants.find(
          (v) => JSON.stringify(v.options) === JSON.stringify(chosen)
        );
        if (!match) return;
        if (idInput) idInput.value = match.id;
        if (priceEl) priceEl.innerHTML = renderPrice(match);
        const skuEl = root.querySelector('[data-sku]');
        if (skuEl) skuEl.textContent = match.sku || 'N/A';
        const notify = root.querySelector('[data-notify]');
        if (notify) notify.hidden = match.available;
        const notifyVar = root.querySelector('[data-notify-variant]');
        if (notifyVar) notifyVar.value = match.title || '';
        if (btn) {
          btn.disabled = !match.available;
          btn.innerHTML = match.available
            ? btn.dataset.available || 'Add to cart'
            : btn.dataset.soldout || 'Sold out';
        }
        const sPrice = document.querySelector('[data-sticky-price]');
        if (sPrice) sPrice.innerHTML = renderPrice(match);
        const sBtn = document.querySelector('[data-sticky-add]');
        if (sBtn) {
          sBtn.disabled = !match.available;
          sBtn.textContent = match.available
            ? sBtn.dataset.available || 'Add to cart'
            : sBtn.dataset.soldout || 'Sold out';
        }
        const stock = root.querySelector('[data-stock-line]');
        if (stock) {
          const textEl = stock.querySelector('[data-stock-text]');
          if (!match.available) {
            stock.hidden = true;
          } else {
            stock.hidden = false;
            const low = parseInt(stock.dataset.low || '6', 10);
            const tracked = match.inventory_management;
            const qty = match.inventory_quantity;
            if (tracked && qty > 0 && qty <= low) {
              stock.classList.add('is-low');
              if (textEl) textEl.textContent = (stock.dataset.onlyLeft || 'Only {{ count }} left').replace('{{ count }}', qty);
            } else {
              stock.classList.remove('is-low');
              if (textEl) textEl.textContent = stock.dataset.inStock || 'In stock';
            }
          }
        }
      }

      form.addEventListener('click', (e) => {
        const opt = e.target.closest('[data-option-index][data-value]');
        if (!opt) return;
        selected[opt.dataset.optionIndex] = opt.dataset.value;
        form
          .querySelectorAll(`[data-option-index="${opt.dataset.optionIndex}"]`)
          .forEach((el) => el.setAttribute('aria-pressed', 'false'));
        opt.setAttribute('aria-pressed', 'true');
        updateSelectedLabel(opt.dataset.optionIndex, opt.dataset.value);
        updateFromSelection();
      });

      form.addEventListener('change', (e) => {
        const sel = e.target.closest('select[data-option-index]');
        if (!sel) return;
        selected[sel.dataset.optionIndex] = sel.value;
        updateSelectedLabel(sel.dataset.optionIndex, sel.value);
        updateFromSelection();
      });
    });
  }

  function renderPrice(variant) {
    if (variant.compare_at_price > variant.price) {
      return `<span class="price__sale">${money(variant.price)}</span>
              <s class="price__compare">${money(variant.compare_at_price)}</s>`;
    }
    return `<span>${money(variant.price)}</span>`;
  }

  /* --- Quantity steppers ------------------------------------------------- */
  function initQuantity() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-qty-change]');
      if (!btn) return;
      const input = btn.parentElement.querySelector('input');
      const step = btn.dataset.qtyChange === 'up' ? 1 : -1;
      const next = Math.max(1, Number(input.value) + step);
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* --- Slideshow --------------------------------------------------------- */
  function initSlideshow() {
    document.querySelectorAll('[data-slideshow-scroll]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const hero = btn.closest('[data-slideshow]');
        if (!hero) return;
        const header = document.querySelector('.header');
        const off = header && getComputedStyle(header).position !== 'static' ? header.getBoundingClientRect().height : 0;
        const y = hero.getBoundingClientRect().bottom + window.scrollY - off;
        window.scrollTo({ top: y, behavior: 'smooth' });
      });
    });
    document.querySelectorAll('[data-slideshow]').forEach(setupSlideshow);
  }

  function setupSlideshow(root) {
    const track = root.querySelector('[data-slides]');
    const slides = Array.from(root.querySelectorAll('[data-slide]'));
    if (slides.length <= 1) return;

    const bullets = Array.from(root.querySelectorAll('[data-slide-to]'));
    const transition = root.dataset.transition || 'fade';
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const autoplay = root.dataset.autoplay === 'true' && !reduce;
    const speed = parseInt(root.dataset.speed, 10) || 5000;
    let index = 0;
    let timer = null;

    function render() {
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      if (transition === 'slide' && track) {
        track.style.transform = `translateX(-${index * 100}%)`;
      }
      bullets.forEach((bullet, i) => {
        if (i === index) bullet.setAttribute('aria-current', 'true');
        else bullet.removeAttribute('aria-current');
      });
    }

    function goTo(i) {
      index = (i + slides.length) % slides.length;
      render();
    }
    const next = () => goTo(index + 1);
    const prev = () => goTo(index - 1);

    function start() {
      if (autoplay && !timer) timer = setInterval(next, speed);
    }
    function stop() {
      clearInterval(timer);
      timer = null;
    }
    const restart = () => {
      stop();
      start();
    };

    root.querySelector('[data-slide-next]')?.addEventListener('click', () => {
      next();
      restart();
    });
    root.querySelector('[data-slide-prev]')?.addEventListener('click', () => {
      prev();
      restart();
    });
    bullets.forEach((bullet) =>
      bullet.addEventListener('click', () => {
        goTo(Number(bullet.dataset.slideTo));
        restart();
      })
    );

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    root.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') {
        next();
        restart();
      } else if (e.key === 'ArrowLeft') {
        prev();
        restart();
      }
    });

    // Touch swipe
    let startX = null;
    root.addEventListener(
      'touchstart',
      (e) => {
        startX = e.touches[0].clientX;
        stop();
      },
      { passive: true }
    );
    root.addEventListener('touchend', (e) => {
      if (startX === null) return;
      const dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) (dx < 0 ? next : prev)();
      startX = null;
      start();
    });

    // Pause when the slideshow scrolls out of view
    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        entries.forEach((entry) => (entry.isIntersecting ? start() : stop()));
      }).observe(root);
    }

    render();
    start();
  }

  /* --- Carousels (blog, etc.) -------------------------------------------- */
  function initCarousels() {
    document.querySelectorAll('[data-carousel]').forEach((root) => {
      const track = root.querySelector('[data-carousel-track]');
      const prev = root.querySelector('[data-carousel-prev]');
      const next = root.querySelector('[data-carousel-next]');
      if (!track) return;

      const step = () => {
        const card = track.firstElementChild;
        if (!card) return track.clientWidth;
        const styles = getComputedStyle(track);
        const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        return card.getBoundingClientRect().width + gap;
      };
      const update = () => {
        const max = track.scrollWidth - track.clientWidth - 2;
        const scrollable = max > 2;
        if (prev) prev.hidden = !scrollable || track.scrollLeft <= 2;
        if (next) next.hidden = !scrollable || track.scrollLeft >= max;
      };

      prev?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      next?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* --- Stats count-up ---------------------------------------------------- */
  function initStats() {
    const els = document.querySelectorAll('[data-count]');
    if (!els.length) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const run = (el) => {
      const raw = (el.textContent || '').trim();
      const m = raw.match(/^([\d.,]+)(.*)$/);
      if (!m) return;
      const target = parseFloat(m[1].replace(/,/g, ''));
      const suffix = m[2] || '';
      if (isNaN(target) || reduce) return;
      const decimals = (m[1].split('.')[1] || '').length;
      const dur = 1400;
      const start = performance.now();
      const step = (now) => {
        const p = Math.min((now - start) / dur, 1);
        const eased = 1 - Math.pow(1 - p, 3);
        const val = target * eased;
        el.textContent = (decimals ? val.toFixed(decimals) : Math.round(val).toLocaleString()) + suffix;
        if (p < 1) requestAnimationFrame(step);
        else el.textContent = (decimals ? target.toFixed(decimals) : Math.round(target).toLocaleString()) + suffix;
      };
      requestAnimationFrame(step);
    };

    if (!('IntersectionObserver' in window)) {
      els.forEach(run);
      return;
    }
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            run(e.target);
            obs.unobserve(e.target);
          }
        });
      },
      { threshold: 0.4 }
    );
    els.forEach((el) => obs.observe(el));
  }

  /* --- Scroll reveal animation ------------------------------------------- */
  function initReveal() {
    const els = document.querySelectorAll('[data-reveal]');
    if (!els.length) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach((el) => el.classList.add('is-visible'));
      return;
    }
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    els.forEach((el) => obs.observe(el));
  }

  /* --- Collection filters (mobile drawer) -------------------------------- */
  function initFacets() {
    const toggle = document.querySelector('[data-facets-toggle]');
    const facets = document.querySelector('[data-facets]');
    if (!toggle || !facets) return;
    const open = () => document.body.classList.add('facets-open');
    const close = () => document.body.classList.remove('facets-open');
    toggle.addEventListener('click', open);
    document.querySelectorAll('[data-facets-close]').forEach((el) =>
      el.addEventListener('click', close)
    );
    document.addEventListener('keydown', (e) => e.key === 'Escape' && close());
  }

  /* --- Price range slider ------------------------------------------------ */
  function initPriceRange() {
    document.querySelectorAll('[data-price-range]').forEach((root) => {
      const min = parseFloat(root.dataset.min) || 0;
      const max = parseFloat(root.dataset.max) || 100;
      const sMin = root.querySelector('[data-price-slider="min"]');
      const sMax = root.querySelector('[data-price-slider="max"]');
      const fill = root.querySelector('[data-price-fill]');
      const form = root.closest('form');
      const nMin = form?.querySelector('[data-price-num="min"]');
      const nMax = form?.querySelector('[data-price-num="max"]');
      if (!sMin || !sMax) return;

      const pct = (v) => ((v - min) / (max - min)) * 100;
      const paint = () => {
        let lo = parseFloat(sMin.value);
        let hi = parseFloat(sMax.value);
        if (lo > hi) {
          [lo, hi] = [hi, lo];
        }
        fill.style.left = pct(lo) + '%';
        fill.style.right = 100 - pct(hi) + '%';
      };
      const fromSlider = () => {
        let lo = parseFloat(sMin.value);
        let hi = parseFloat(sMax.value);
        if (lo > hi) [lo, hi] = [hi, lo];
        if (nMin) nMin.value = Math.round(lo);
        if (nMax) nMax.value = Math.round(hi);
        paint();
      };
      sMin.addEventListener('input', fromSlider);
      sMax.addEventListener('input', fromSlider);
      nMin?.addEventListener('change', () => {
        sMin.value = nMin.value || min;
        paint();
      });
      nMax?.addEventListener('change', () => {
        sMax.value = nMax.value || max;
        paint();
      });
      paint();
    });
  }

  /* --- Collection grid column switcher ----------------------------------- */
  function initGridSwitch() {
    const sw = document.querySelector('[data-grid-switch]');
    const grid = document.querySelector('[data-product-grid]');
    if (!sw || !grid) return;
    const btns = Array.from(sw.querySelectorAll('[data-cols]'));
    const allowed = btns.map((b) => b.dataset.cols);

    const apply = (cols, save) => {
      if (!allowed.includes(cols)) return;
      grid.style.setProperty('--cols', cols);
      btns.forEach((b) => b.classList.toggle('is-active', b.dataset.cols === cols));
      if (save) {
        try { localStorage.setItem('kd-collection-cols', cols); } catch (_) {}
      }
    };

    let saved = null;
    try { saved = localStorage.getItem('kd-collection-cols'); } catch (_) {}
    if (saved) apply(saved, false);

    btns.forEach((b) => b.addEventListener('click', () => apply(b.dataset.cols, true)));
  }

  /* --- Filter-bar dropdowns: close others / outside click ---------------- */
  function initFilterBar() {
    const drops = Array.from(document.querySelectorAll('[data-fdrop]'));
    if (!drops.length) return;
    drops.forEach((d) => {
      d.addEventListener('toggle', () => {
        if (d.open) drops.forEach((o) => { if (o !== d) o.open = false; });
      });
    });
    document.addEventListener('click', (e) => {
      if (!e.target.closest('[data-fdrop]')) drops.forEach((d) => (d.open = false));
    });
  }

  /* --- Server-rendered toasts (data-toast) ------------------------------- */
  function initInlineToasts() {
    document.querySelectorAll('[data-toast]').forEach((el) => {
      Toast.show(el.dataset.toast, el.dataset.toastType || 'success');
      el.remove();
    });
  }

  /* --- Reviews: sort & filter -------------------------------------------- */
  function initReviews() {
    const root = document.querySelector('[data-reviews]');
    if (!root) return;
    const list = root.querySelector('[data-reviews-list]');
    if (!list) return;
    const items = Array.from(list.querySelectorAll('[data-review]'));
    if (!items.length) return;

    const sortSel = root.querySelector('[data-reviews-sort]');
    const clearBtn = root.querySelector('[data-review-clear]');
    const emptyMsg = root.querySelector('[data-reviews-empty-filter]');
    const showing = root.querySelector('[data-reviews-showing]');
    const filterBtns = Array.from(root.querySelectorAll('[data-review-filter]'));
    let activeRating = 0;

    function apply() {
      const sort = sortSel ? sortSel.value : 'newest';
      const ordered = items.slice().sort((a, b) => {
        const da = a.dataset.date || '';
        const db = b.dataset.date || '';
        const ra = Number(a.dataset.rating) || 0;
        const rb = Number(b.dataset.rating) || 0;
        if (sort === 'oldest') return da.localeCompare(db);
        if (sort === 'highest') return rb - ra || db.localeCompare(da);
        if (sort === 'lowest') return ra - rb || db.localeCompare(da);
        return db.localeCompare(da); // newest
      });

      let visible = 0;
      ordered.forEach((el) => {
        const show = !activeRating || Number(el.dataset.rating) === activeRating;
        el.hidden = !show;
        if (show) visible += 1;
        list.appendChild(el);
      });

      if (emptyMsg) emptyMsg.hidden = visible > 0;
      if (clearBtn) clearBtn.hidden = !activeRating;
      if (showing) showing.textContent = showing.dataset.tpl
        ? showing.dataset.tpl.replace('##', visible)
        : `${visible}`;
    }

    sortSel?.addEventListener('change', apply);
    filterBtns.forEach((btn) =>
      btn.addEventListener('click', () => {
        const val = Number(btn.dataset.reviewFilter);
        activeRating = activeRating === val ? 0 : val;
        filterBtns.forEach((b) =>
          b.setAttribute('aria-pressed', String(Number(b.dataset.reviewFilter) === activeRating))
        );
        apply();
      })
    );
    clearBtn?.addEventListener('click', () => {
      activeRating = 0;
      filterBtns.forEach((b) => b.setAttribute('aria-pressed', 'false'));
      apply();
    });

    apply();
  }

  /* --- Product social proof + share -------------------------------------- */
  const rand = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

  function initProductExtras() {
    // "X sold in last Y hours"
    const sold = document.querySelector('[data-sold]');
    if (sold) {
      sold.querySelector('[data-sold-count]').textContent = rand(12, 45);
      sold.querySelector('[data-sold-hours]').textContent = rand(6, 24);
      sold.hidden = false;
    }

    // "X customers are viewing" — with occasional live drift
    const viewers = document.querySelector('[data-viewers]');
    if (viewers) {
      const countEl = viewers.querySelector('[data-viewers-count]');
      let n = rand(18, 55);
      countEl.textContent = n;
      viewers.hidden = false;
      setInterval(() => {
        n = Math.max(8, n + rand(-2, 2));
        countEl.textContent = n;
      }, 6000);
    }

    // Estimated delivery dates
    document.querySelectorAll('[data-delivery]').forEach((el) => {
      const min = parseInt(el.dataset.minDays, 10) || 3;
      const max = parseInt(el.dataset.maxDays, 10) || 9;
      const locale = document.documentElement.lang || 'en';
      const fmt = (d) => d.toLocaleDateString(locale, { day: '2-digit', month: 'long' });
      const now = new Date();
      const d1 = new Date(now);
      d1.setDate(now.getDate() + min);
      const d2 = new Date(now);
      d2.setDate(now.getDate() + max);
      const minEl = el.querySelector('[data-delivery-min]');
      const maxEl = el.querySelector('[data-delivery-max]');
      if (minEl) minEl.textContent = fmt(d1);
      if (maxEl) maxEl.textContent = fmt(d2);
    });

    // Share button (Web Share API with clipboard fallback)
    document.querySelectorAll('[data-share]').forEach((btn) => {
      btn.addEventListener('click', async () => {
        const url = btn.dataset.shareUrl || location.href;
        const title = btn.dataset.shareTitle || document.title;
        if (navigator.share) {
          try {
            await navigator.share({ title, url });
          } catch (_) {}
        } else {
          try {
            await navigator.clipboard.writeText(url);
            Toast.show(window.themeStrings?.linkCopied || 'Link copied', 'success', 2500);
          } catch (_) {}
        }
      });
    });
  }

  /* --- Copy-to-clipboard buttons ----------------------------------------- */
  function initCopyButtons() {
    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-copy]');
      if (!btn) return;
      e.preventDefault();
      try {
        await navigator.clipboard.writeText(btn.dataset.copy);
        Toast.show(btn.dataset.copiedMessage || window.themeStrings?.linkCopied || 'Copied', 'success', 2500);
      } catch (_) {}
    });
  }

  /* --- Delayed newsletter popup ------------------------------------------ */
  function initNewsletterPopup() {
    const el = document.querySelector('[data-newsletter-popup]');
    if (!el) return;
    const KEY = 'kd-newsletter-popup-v2';
    const days = parseInt(el.dataset.days || '7', 10);
    const delayMs = (parseInt(el.dataset.delay || '12', 10) || 0) * 1000;

    const mark = () => {
      try { localStorage.setItem(KEY, Date.now().toString()); } catch (_) {}
    };
    const suppressed = () => {
      if (days <= 0) return false;
      try {
        const t = parseInt(localStorage.getItem(KEY) || '0', 10);
        return t > 0 && Date.now() - t < days * 86400000;
      } catch (_) {
        return false;
      }
    };
    const open = () => {
      el.hidden = false;
      requestAnimationFrame(() => el.classList.add('is-open'));
      document.body.style.overflow = 'hidden';
      mark();
    };
    const close = () => {
      el.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(() => { el.hidden = true; }, 300);
    };

    el.querySelectorAll('[data-np-close]').forEach((b) => b.addEventListener('click', close));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && el.classList.contains('is-open')) close();
    });
    const form = el.querySelector('form');
    if (form) form.addEventListener('submit', mark);

    // Just subscribed (page reloaded on success) → open immediately to show the code.
    if (el.querySelector('[data-np-success]')) { open(); return; }
    if (suppressed()) return;
    setTimeout(open, delayMs);
  }

  /* --- Volume discount tiers --------------------------------------------- */
  function initVolumeDiscounts() {
    document.querySelectorAll('[data-volume]').forEach((root) => {
      const tiers = Array.from(root.querySelectorAll('[data-volume-tier]'));
      if (!tiers.length) return;
      const form = document.querySelector('[data-product-form]');
      const qtyInput = form ? form.querySelector('[name="quantity"]') : null;

      const highlight = () => {
        const q = qtyInput ? Number(qtyInput.value) || 1 : 1;
        let active = -1;
        tiers.forEach((t, i) => { if (q >= Number(t.dataset.qty)) active = i; });
        tiers.forEach((t, i) => t.classList.toggle('is-active', i === active));
      };
      tiers.forEach((t) =>
        t.addEventListener('click', () => {
          if (qtyInput) {
            qtyInput.value = t.dataset.qty;
            qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
          highlight();
        })
      );
      if (qtyInput) qtyInput.addEventListener('change', highlight);
      highlight();
    });
  }

  /* --- Product bundle (add all) ------------------------------------------ */
  function initBundle() {
    document.querySelectorAll('[data-bundle-add]').forEach((btn) => {
      btn.addEventListener('click', async () => {
        const ids = (btn.dataset.ids || '').split(',').map((s) => s.trim()).filter(Boolean);
        if (!ids.length) return;
        const label = btn.innerHTML;
        btn.setAttribute('aria-disabled', 'true');
        btn.innerHTML = btn.dataset.adding || 'Adding…';
        try {
          const items = ids.map((id) => ({ id: Number(id), quantity: 1 }));
          const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
          });
          if (!res.ok) throw new Error('add failed');
          await updateCartCount();
          await CartDrawer.refresh();
          CartDrawer.open();
        } catch (err) {
          console.error(err);
        } finally {
          btn.removeAttribute('aria-disabled');
          btn.innerHTML = label;
        }
      });
    });
  }

  /* --- Product comparison ------------------------------------------------ */
  function initCompare() {
    const KEY = 'kd-compare';
    const MAX = 4;
    const bar = document.querySelector('[data-compare-bar]');
    const modal = document.querySelector('[data-compare-modal]');
    if (!bar && !modal) return;
    const esc = (s) => String(s || '').replace(/"/g, '&quot;');
    const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (_) { return []; } };
    const write = (a) => { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (_) {} };
    let labels = {};
    try { labels = JSON.parse(modal?.querySelector('[data-compare-labels]')?.textContent || '{}'); } catch (_) {}

    const snapshot = (b) => ({
      id: b.dataset.compareAdd, handle: b.dataset.compareHandle, url: b.dataset.compareUrl,
      title: b.dataset.compareTitle, image: b.dataset.compareImage, price: b.dataset.comparePrice,
    });

    function syncButtons() {
      const ids = read().map((x) => String(x.id));
      document.querySelectorAll('[data-compare-add]').forEach((b) => {
        const on = ids.indexOf(String(b.dataset.compareAdd)) > -1;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    function renderBar() {
      if (!bar) return;
      const list = read();
      const track = bar.querySelector('[data-compare-track]');
      const count = bar.querySelector('[data-compare-count]');
      if (count) count.textContent = list.length;
      if (track) {
        track.innerHTML = list
          .map((p) => `<span class="compare-bar__item"><img src="${esc(p.image)}" alt=""><button type="button" class="compare-bar__remove" data-compare-remove="${esc(p.id)}" aria-label="remove">&times;</button></span>`)
          .join('');
      }
      const openBtn = bar.querySelector('[data-compare-open]');
      if (openBtn) openBtn.disabled = list.length < 2;
      bar.hidden = list.length === 0;
    }
    function toggle(snap) {
      let list = read();
      if (list.some((x) => String(x.id) === String(snap.id))) {
        list = list.filter((x) => String(x.id) !== String(snap.id));
      } else {
        if (list.length >= MAX) { if (window.Toast) Toast.show(labels.limit || 'Limit', 'error', 3000); return; }
        list.push(snap);
      }
      write(list); renderBar(); syncButtons();
    }

    document.addEventListener('click', (e) => {
      const addBtn = e.target.closest('[data-compare-add]');
      if (addBtn) { e.preventDefault(); toggle(snapshot(addBtn)); return; }
      const rm = e.target.closest('[data-compare-remove]');
      if (rm) { write(read().filter((x) => String(x.id) !== String(rm.dataset.compareRemove))); renderBar(); syncButtons(); return; }
      if (e.target.closest('[data-compare-clear]')) { write([]); renderBar(); syncButtons(); return; }
      if (e.target.closest('[data-compare-open]')) { openModal(); return; }
      if (e.target.closest('[data-compare-close]')) { modal?.classList.remove('is-open'); document.body.style.overflow = ''; return; }
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal?.classList.contains('is-open')) { modal.classList.remove('is-open'); document.body.style.overflow = ''; }
    });

    async function openModal() {
      if (!modal) return;
      const list = read();
      if (list.length < 2) return;
      const body = modal.querySelector('[data-compare-content]');
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      if (body) body.innerHTML = '<p class="compare-modal__loading">…</p>';
      const root = window.Shopify?.routes?.root || '/';
      const products = (
        await Promise.all(list.map((p) => fetch(`${root}products/${p.handle}.js`).then((r) => r.json()).catch(() => null)))
      ).filter(Boolean);
      if (!products.length || !body) { if (body) body.innerHTML = ''; return; }

      const optionNames = [];
      products.forEach((p) => (p.options || []).forEach((o) => {
        const n = typeof o === 'string' ? o : o.name;
        if (n && optionNames.indexOf(n) === -1) optionNames.push(n);
      }));
      const cell = (p, key) => {
        if (key === 'price') return money(p.price);
        if (key === 'availability') return p.available ? `<span class="compare-yes">${esc(labels.in_stock)}</span>` : `<span class="compare-no">${esc(labels.sold_out)}</span>`;
        if (key === 'type') return esc(p.type) || '—';
        if (key === 'vendor') return esc(p.vendor) || '—';
        const opt = (p.options || []).find((o) => (typeof o === 'string' ? o : o.name) === key);
        if (opt) {
          const idx = (p.options || []).indexOf(opt);
          const vals = Array.from(new Set((p.variants || []).map((v) => v[`option${idx + 1}`]).filter(Boolean)));
          return vals.length ? vals.map(esc).join(', ') : '—';
        }
        return '—';
      };
      const rows = [['price', labels.price], ['availability', labels.availability], ['type', labels.type], ['vendor', labels.vendor]]
        .concat(optionNames.map((n) => [n, n]));
      let html = '<div class="compare-table-wrap"><table class="compare-table"><thead><tr><th></th>';
      products.forEach((p) => {
        const img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=240' : '';
        html += `<th><a href="${p.url}" class="compare-head"><span class="compare-head__media">${img ? `<img src="${img}" alt="${esc(p.title)}">` : ''}</span><span class="compare-head__title">${esc(p.title)}</span></a></th>`;
      });
      html += '</tr></thead><tbody>';
      rows.forEach(([key, label]) => {
        html += `<tr><th scope="row">${esc(label)}</th>`;
        products.forEach((p) => { html += `<td>${cell(p, key)}</td>`; });
        html += '</tr>';
      });
      html += '<tr><th scope="row"></th>';
      products.forEach((p) => { html += `<td><a href="${p.url}" class="btn btn--secondary compare-view">${esc(labels.view)}</a></td>`; });
      html += '</tr></tbody></table></div>';
      body.innerHTML = html;
    }

    renderBar();
    syncButtons();
  }

  /* --- Cart reservation countdown ---------------------------------------- */
  function initCartTimer() {
    const KEY = 'kd-cart-timer-end';
    const tick = () => {
      const els = document.querySelectorAll('[data-cart-timer]');
      if (!els.length) return;
      const minutes = parseInt(els[0].dataset.minutes || '10', 10);
      const now = Date.now();
      let end = parseInt(sessionStorage.getItem(KEY) || '0', 10);
      if (!end || end < now) {
        end = now + minutes * 60000;
        try { sessionStorage.setItem(KEY, String(end)); } catch (_) {}
      }
      const left = Math.max(0, Math.floor((end - now) / 1000));
      const mm = String(Math.floor(left / 60)).padStart(2, '0');
      const ss = String(left % 60).padStart(2, '0');
      els.forEach((el) => {
        const v = el.querySelector('[data-cart-timer-value]');
        if (v) v.textContent = `${mm}:${ss}`;
      });
    };
    tick();
    setInterval(tick, 1000);
  }

  /* --- Recently viewed products ------------------------------------------ */
  function initRecentlyViewed() {
    const KEY = 'kd-recent';
    const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (_) { return []; } };
    const write = (a) => { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (_) {} };
    const esc = (s) => String(s || '').replace(/"/g, '&quot;');

    const rec = document.querySelector('[data-recently-viewed-add]');
    if (rec) {
      try {
        const p = JSON.parse(rec.textContent);
        if (p && p.id) {
          const list = read().filter((x) => x.id !== p.id);
          list.unshift(p);
          write(list.slice(0, 12));
        }
      } catch (_) {}
    }

    document.querySelectorAll('[data-recently-viewed]').forEach((box) => {
      const grid = box.querySelector('[data-recently-grid]');
      if (!grid) return;
      const current = box.dataset.current || '';
      const limit = parseInt(box.dataset.limit || '6', 10);
      const items = read().filter((x) => String(x.id) !== current).slice(0, limit);
      if (!items.length) return;
      grid.innerHTML = items
        .map(
          (p) => `<a href="${p.url}" class="showcase-card">
            <span class="showcase-card__media" style="display:block">${p.image ? `<img src="${p.image}" alt="${esc(p.title)}" loading="lazy">` : ''}</span>
            <span class="showcase-card__title">${esc(p.title)}</span>
            <span class="showcase-card__price">${esc(p.price)}</span>
          </a>`
        )
        .join('');
      box.hidden = false;
    });
  }

  /* --- Countdown timer --------------------------------------------------- */
  function initCountdown() {
    document.querySelectorAll('[data-countdown]').forEach((root) => {
      const end = new Date((root.dataset.end || '').trim().replace(' ', 'T')).getTime();
      if (isNaN(end)) return;
      const pad = (n) => String(n).padStart(2, '0');
      const d = root.querySelector('[data-cd-days]');
      const h = root.querySelector('[data-cd-hours]');
      const m = root.querySelector('[data-cd-mins]');
      const s = root.querySelector('[data-cd-secs]');
      let timer = null;
      const tick = () => {
        const diff = end - Date.now();
        if (diff <= 0) {
          clearInterval(timer);
          root.innerHTML = '<p class="countdown__ended">' + (root.dataset.ended || '') + '</p>';
          return;
        }
        if (d) d.textContent = pad(Math.floor(diff / 86400000));
        if (h) h.textContent = pad(Math.floor((diff % 86400000) / 3600000));
        if (m) m.textContent = pad(Math.floor((diff % 3600000) / 60000));
        if (s) s.textContent = pad(Math.floor((diff % 60000) / 1000));
      };
      tick();
      timer = setInterval(tick, 1000);
    });
  }

  /* --- Size guide modal -------------------------------------------------- */
  function initSizeGuide() {
    const modal = document.querySelector('[data-sizeguide-modal]');
    if (!modal) return;
    const open = () => {
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    };
    const close = () => {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
    };
    document.querySelectorAll('[data-sizeguide-open]').forEach((b) => b.addEventListener('click', open));
    modal.querySelectorAll('[data-sizeguide-close], .sizeguide__overlay').forEach((el) => el.addEventListener('click', close));
    document.addEventListener('keydown', (e) => e.key === 'Escape' && close());
  }

  /* --- Featured tabs showcase (homepage) --------------------------------- */
  function initShowcaseTabs() {
    document.querySelectorAll('[data-showcase]').forEach((root) => {
      const tabs = Array.from(root.querySelectorAll('[data-showcase-tab]'));
      const panels = Array.from(root.querySelectorAll('[data-showcase-panel]'));
      if (!tabs.length) return;
      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const idx = tab.dataset.showcaseTab;
          tabs.forEach((t) => {
            const on = t === tab;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          panels.forEach((p) => {
            const on = p.dataset.showcasePanel === idx;
            p.classList.toggle('is-hidden', !on);
            p.hidden = !on;
          });
        });
      });
    });
  }

  /* --- Sticky add-to-cart bar (product page) ----------------------------- */
  function initStickyAtc() {
    const bar = document.querySelector('[data-sticky-atc]');
    const realBtn = document.querySelector('[data-add-btn]');
    if (!bar || !realBtn) return;
    const header = document.querySelector('.header');

    function headerOffset() {
      if (!header) return 0;
      const pos = getComputedStyle(header).position;
      return pos === 'sticky' || pos === 'fixed' ? header.getBoundingClientRect().height : 0;
    }
    const setTop = () => { bar.style.top = headerOffset() + 'px'; };
    setTop();
    bar.hidden = false;

    const onScroll = () => {
      // Appear immediately as soon as the user scrolls down a little.
      const show = window.scrollY > 120;
      bar.classList.toggle('is-visible', show);
      document.body.classList.toggle('atc-visible', show);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', () => { setTop(); onScroll(); });

    const sBtn = bar.querySelector('[data-sticky-add]');
    if (sBtn) sBtn.addEventListener('click', () => realBtn.click());
  }

  /* --- Product tabs ------------------------------------------------------ */
  function initTabs() {
    document.querySelectorAll('[data-tabs]').forEach((root) => {
      const tabs = Array.from(root.querySelectorAll('.tabs__tab'));
      const panels = Array.from(root.querySelectorAll('[data-panel]'));
      tabs.forEach((btn) => {
        btn.addEventListener('click', () => {
          if (btn.dataset.tabScroll) {
            const target = document.querySelector(btn.dataset.tabScroll);
            if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            return;
          }
          const name = btn.dataset.tab;
          tabs.forEach((t) => t.classList.toggle('is-active', t === btn));
          panels.forEach((p) => p.classList.toggle('is-active', p.dataset.panel === name));
        });
      });
    });
  }

  /* --- Quick view -------------------------------------------------------- */
  const QuickView = {
    modal: null,
    content: null,
    init() {
      this.modal = document.querySelector('[data-quickview-modal]');
      if (!this.modal) return;
      this.content = this.modal.querySelector('[data-quickview-content]');

      document.addEventListener('click', (e) => {
        const trigger = e.target.closest('[data-quickview]');
        if (!trigger) return;
        e.preventDefault();
        this.open(trigger.getAttribute('href') || trigger.dataset.quickview);
      });
      this.modal
        .querySelectorAll('[data-quickview-close], .quickview__overlay')
        .forEach((el) => el.addEventListener('click', () => this.close()));
      document.addEventListener('keydown', (e) => e.key === 'Escape' && this.close());
    },
    async open(url) {
      if (!url) return;
      this.content.innerHTML = '<div class="quickview__loading">' + (window.themeStrings?.loading || '…') + '</div>';
      this.modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      try {
        const sep = url.includes('?') ? '&' : '?';
        const res = await fetch(`${url}${sep}section_id=quick-view`);
        const text = await res.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const inner = doc.querySelector('[data-quickview-section]');
        this.content.innerHTML = inner ? inner.innerHTML : '';
        initVariants(this.content);
        markWishlistButtons();
      } catch (err) {
        console.error(err);
        this.close();
      }
    },
    close() {
      this.modal.classList.remove('is-open');
      document.body.style.overflow = '';
    },
  };

  /* --- Product recommendations ------------------------------------------- */
  function initRecommendations() {
    document.querySelectorAll('[data-product-recommendations]').forEach((el) => {
      if (!el.dataset.url) return;
      fetch(el.dataset.url)
        .then((r) => r.text())
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const fresh = doc.querySelector('[data-product-recommendations]');
          if (fresh && fresh.innerHTML.trim().length) {
            el.innerHTML = fresh.innerHTML;
            markWishlistButtons();
          }
        })
        .catch((err) => console.error(err));
    });
  }

  /* --- Init -------------------------------------------------------------- */
  document.addEventListener('DOMContentLoaded', () => {
    initMobileNav();
    initTransparentHeader();
    initStickyHeader();
    initMegaMenu();
    initMobileSubmenus();
    CartDrawer.init();
    initAddToCart();
    initCartChanges();
    initGallery();
    /* initImageZoom(); — hover magnify disabled; gallery uses prev/next arrows */
    Lightbox.init();
    initVariants();
    initStickyAtc();
    initQuantity();
    initSlideshow();
    initWishlist();
    SearchModal.init();
    AccountModal.init();
    initCarousels();
    initReveal();
    initStats();
    initReviews();
    initFacets();
    initPriceRange();
    initGridSwitch();
    initFilterBar();
    initWishlistPage();
    initProductExtras();
    initTabs();
    initShowcaseTabs();
    initCountdown();
    initSizeGuide();
    QuickView.init();
    initRecommendations();
    initCopyButtons();
    initNewsletterPopup();
    initRecentlyViewed();
    initCartTimer();
    initCompare();
    initVolumeDiscounts();
    initBundle();
    initFlash();
    initInlineToasts();
    updateCartCount();
  });
})();
